import { render, staticRenderFns } from "./csc2-vdo.vue?vue&type=template&id=0d0cfbc7&scoped=true&"
import script from "./csc2-vdo.vue?vue&type=script&lang=tsx&"
export * from "./csc2-vdo.vue?vue&type=script&lang=tsx&"
import style0 from "./csc2-vdo.vue?vue&type=style&index=0&id=0d0cfbc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cfbc7",
  null
  
)

export default component.exports